import React, { useState, useEffect } from "react";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { API, Storage } from "aws-amplify";
import { useNavigate } from 'react-router-dom';
import { listProducts } from "../graphql/queries";
import { NoItemsFound } from "./NoItemsFound";
import ProductList from "./ProductList";
import "./Home.css";
import Cookies from 'js-cookie';

// Ensure cookies are configured correctly
Cookies.set('sameSite', 'none', { secure: true });

Storage.configure({ track: true, level: "public" });

async function getSignedUri(key) {
  return await Storage.get(key);
}

export const ControlPanel = () => {
  const [controlPanelPage, setControlPanelPage] = useState();

  useEffect(() => {
    async function checkProducts() {
      async function fetchImages() {
        const result_dict = {};
        const BATCH_SIZE = 10; // Limit concurrent requests to avoid throttling
        
        const result = await Storage.list('', { 
          level: "public",
          pageSize: 100, // Smaller page size for efficient resource handling
        });

        // Break down into batches to control concurrency
        const processBatch = async (batch) => {
          const batchPromises = batch.map(async (item) => {
            item.signedUrl = await getSignedUri(item.key);
            result_dict[item.key] = item.signedUrl;
          });
          await Promise.all(batchPromises);
        };

        // Split results into smaller batches
        for (let i = 0; i < result.results.length; i += BATCH_SIZE) {
          const batch = result.results.slice(i, i + BATCH_SIZE);
          await processBatch(batch);
        }
        return result_dict;
      }

      async function fetchProducts() {
        const apiData = await API.graphql({
          query: listProducts,
          variables: {
            filter: {
              _deleted: { ne: true }
            }
          }
        });
        return apiData.data.listProducts.items;
      }

      // Fetch images and products concurrently
      try {
        const [images, products] = await Promise.all([fetchImages(), fetchProducts()]);
        if (images && products && products.length > 0) {
          setControlPanelPage(<ProductList products={products} images={images} />);
        } else {
          setControlPanelPage(<NoItemsFound />);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setControlPanelPage(<NoItemsFound />);
      }
    }
    checkProducts();
  }, []);

  return <div>{controlPanelPage}</div>;
};

export function HomeProducer() {
  const navigate = useNavigate();
  const { user } = useAuthenticator((context) => [context.user]);
  const [homePage, setHomePage] = useState();

  useEffect(() => {
    async function atLeastOneProduct() {
      try {
        const apiData = await API.graphql({
          query: listProducts,
          variables: {
            filter: {
              _deleted: { ne: true }
            }
          }
        });
        const productCount = apiData.data.listProducts.items.length;
        if (productCount >= 1) {
          setHomePage(<ControlPanel />);
        } else {
          navigate('/welcome');
        }
      } catch (error) {
        console.error("Error checking products:", error);
        navigate('/welcome');
      }
    }
    atLeastOneProduct();
  }, [user, navigate]);

  return <div>{homePage}</div>;
}
